<!-- Affichage des cellules de type 'Date' -->
@if (cellType === CellType.Date) {
    <span [ngClass]="{ unread: !data.isRead }">
        {{ data | avmDocumentCellPipe: column | date: FRENCH_DATETIME_FORMAT }}
    </span>
}

<!-- Affichage des cellules de type 'Date & heure' -->
@if (cellType === CellType.DateAndTime) {
    <span [ngClass]="{ unread: !data.isRead }">
        {{ data | avmDocumentCellPipe: column | date: FRENCH_DATETIME_FORMAT }}
    </span>
}

<!-- Affichage des icones de la colonne type du tableau des Documents -->
@if (cellType === CellType.Enum && column.propertyCode === TYPE) {
    @switch (data.type) {
        @case (DocumentType.Email) {
            <mat-icon matTooltip="Email" [ngClass]="{ unread: !data.isRead }">email</mat-icon>
        }
        @case (DocumentType.Sms) {
            <mat-icon matTooltip="SMS" [ngClass]="{ unread: !data.isRead }">sms</mat-icon>
        }
        @case (DocumentType.Fax) {
            <mat-icon matTooltip="Fax" [ngClass]="{ unread: !data.isRead }">print</mat-icon>
        }
        @case (DocumentType.File) {
            <mat-icon matTooltip="Fichier" [ngClass]="{ unread: !data.isRead }">insert_drive_file</mat-icon>
        }
        @case (DocumentType.Tchat) {
            <mat-icon matTooltip="Tchat" [ngClass]="{ unread: !data.isRead }">question_answer</mat-icon>
        }
        @case (DocumentType.Comment) {
            <mat-icon matTooltip="Commentaire" [ngClass]="{ unread: !data.isRead }">mode_comment</mat-icon>
        }
        @case (DocumentType.MergedComment) {
            <mat-icon matTooltip="Commentaire issue d'une fusion" [ngClass]="{ unread: !data.isRead }">mode_comment</mat-icon>
        }
    }
}

<!-- Affichage des icones de la colonne flux du tableau des Documents -->
@if (cellType === CellType.Enum && column.propertyCode === FLUX) {
    @switch (data.flux) {
        @case (DocumentFlux.Receive) {
            <mat-icon [ngClass]="{ unread: !data.isRead }">arrow_forward</mat-icon>
        }
        @case (DocumentFlux.Transmission) {
            <mat-icon [ngClass]="{ unread: !data.isRead }">arrow_back</mat-icon>
        }
        @case (DocumentFlux.Upload) {
            <mat-icon [ngClass]="{ unread: !data.isRead }">file_upload</mat-icon>
        }
    }
}

<!-- Affichage des cellules de type 'Liste' -->
@if (cellType === CellType.List && hasAttachment === true) {
    <mat-icon [ngClass]="{ unread: !data.isRead }">attach_file</mat-icon>
}

<!-- Affichage des cellules standards -->
@if (cellType === CellType.Standard) {
    @if (column.propertyCode === FROM || column.propertyCode === TO) {
        <!-- Affichage des cellules standards affichant des adresses mails -->
        <span class="overflow-ellipsis" [ngClass]="{ unread: !data.isRead }" [title]="data | avmDocumentCellPipe: column">
            {{ data | avmDocumentCellPipe: column | avmEmailAddresses }}
        </span>
    } @else {
        <span class="overflow-ellipsis" [ngClass]="{ unread: !data.isRead }" [title]="data | avmDocumentCellPipe: column">
            {{ data | avmDocumentCellPipe: column }}
        </span>
    }
}
